<template>
  <footer class="ride-list__card__footer">
    <div
      v-if="status === 'WAITING_DRIVERS_ANSWERS'"
      class="list__card__footer__item"
    >
      <a
        class="list__card__footer__action list__card__footer__action--accent"
        @click.prevent="handleClick('cancel')"
      >
        <span class="list__card__footer__action__text">
          {{ $t(`${namespace}.cancelRide`) }}
        </span>
      </a>
    </div>

    <div
      v-if="status === 'RIDE_ENDED'"
      class="list__card__footer__item"
    >
      <a
        class="list__card__footer__action list__card__footer__action--accent"
        @click.prevent="handleClick('viewDetails')"
      >
        <span class="list__card__footer__action__text">
          {{ $t(`${namespace}.viewDetails`) }}
        </span>
        <v-icon class="list__card__footer__action__icon" small>
          keyboard_arrow_right
        </v-icon>
      </a>
    </div>

    <div
      v-if="
        status === 'COULDNT_FIND_AVAILABLE_DRIVERS' ||
        status === 'CANCELED_BY_PASSENGER'
      "
      class="list__card__footer__item"
    >
      <a
        class="list__card__footer__action list__card__footer__action--accent"
        @click.prevent="handleClick('discard')"
      >
        <span class="list__card__footer__action__text">
          {{ $t(`${namespace}.discard`) }}
        </span>
      </a>
    </div>

    <div
      v-if="
        status === 'DRIVERS_REJECTED' ||
        status === 'CANCELED_BY_DRIVER'
      "
      class="list__card__footer__item"
    >
      <a
        class="list__card__footer__action list__card__footer__action--accent"
        @click.prevent="handleClick('callAgain')"
      >
        <span class="list__card__footer__action__text">
          {{ $t(`${namespace}.callAgain`) }}
        </span>
      </a>
    </div>

    <div
      v-if="
        status === 'CAR_ON_THE_WAY' ||
        status === 'IN_PROGRESS' ||
        status === 'WAITING_FOR_PASSENGER' ||
        status === 'CAR_ARRIVED'
      "
      class="list__card__footer__item"
    >
      <a
        class="list__card__footer__action list__card__footer__action--2col list__card__footer__action--accent"
        @click.prevent="handleClick('viewDetails')"
      >
        <span class="list__card__footer__action__text">
          {{ $t(`${namespace}.viewDetails`) }}
        </span>
        <v-icon class="list__card__footer__action__icon" small>
          keyboard_arrow_right
        </v-icon>
      </a>

      <a
        v-if="false"
        class="list__card__footer__action list__card__footer__action--2col"
        @click.prevent="handleClick('talkToDriver')"
      >
        <span class="list__card__footer__action__text">
          {{ $t(`${namespace}.talkToDriver`) }}
        </span>
        <v-icon class="list__card__footer__action__icon" small>
          keyboard_arrow_right
        </v-icon>
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    ride: {
      type: Object,
      required: true
    }
  },
  computed: {
    status () {
      return this.ride && this.ride.status ? this.ride.status : null
    },

    rideId () {
      return this.ride && this.ride.running && this.ride.running.rideID
        ? this.ride.running.rideID
        : null
    }
  },
  data () {
    return {
      namespace: 'Views.NewWebCallPage.rideList.card'
    }
  },
  methods: {
    handleClick (event) {
      this.$emit('rideEvent', {
        event,
        rideId: this.rideId,
        ride: this.ride
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ride-list__card__footer {
  align-items: center;
  border-bottom: 1px solid $gray-4;
  border-top: 1px solid $gray-4;
  display: flex;
  height: 43px;
  justify-content: center;
}

.list__card__footer__item {
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: center;
}

.list__card__footer__action {
  align-items: center;
  display: flex;
  font-size: 12px;
  justify-content: center;
  transition: background .26s;
  width: 100%;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  &.list__card__footer__action--2col {
    width: 50%;
  }

  &:nth-child(2) {
    border-left: 1px solid $gray-3;
  }

  &.list__card__footer__action--accent {
    color: $accent;

    .list__card__footer__action__text,
    .list__card__footer__action__icon {
      color: $accent;
    }
  }
}

.list__card__footer__action__text,
.list__card__footer__action__icon {
  color: $gray-8;
}

.list__card__footer__action__text {
  font-weight: 600;
}
</style>
